const VENDOR_ADMIN_ROLE_IDS = ['role.eva.vendor.admin', 'role.vendor-portal.vendor.admin', 'VENDOR_ADMIN'];
const PB_SUPPORT_ROLE_IDS = ['role.iam.pb.support', 'role.vendor-portal.pb.support', 'PB_SUPPORT'];
const PB_ADMIN_ROLE_IDS = ['role.iam.pb.admin', 'role.vendor-portal.pb.admin', 'PB_ADMIN'];

export const isVendorAdminRole = (roleId: string | null | undefined): boolean => {
    return roleId !== null && roleId !== undefined && VENDOR_ADMIN_ROLE_IDS.includes(roleId);
};

export const isPbSupportRole = (roleId: string | null | undefined): boolean => {
    return roleId !== null && roleId !== undefined && PB_SUPPORT_ROLE_IDS.includes(roleId);
};

export const isPbAdminRole = (roleId: string | null | undefined): boolean => {
    return roleId !== null && roleId !== undefined && PB_ADMIN_ROLE_IDS.includes(roleId);
};
